<template>

   <div class="container-fluid">
       <div class="title text-left">Nos clients</div>
       <div class="highlighted"> Nos références témoignent de la qualité et de l'apport de nos solutions </div>

       <div class="row">
            <div class="col card">
                <div class="highlighted">Vivescia</div>
                <div>Coopérative céréalière de 11000 adhérents, classée 6 ème coopérative de France</div>
            </div>
            <div class="col card col-lg-4">
                <div class="highlighted">Sévéal</div>
                <div>Centrale d'achat regroupant 6 coopératives du Grand-Est pour PSV, semences hybrides et engrais</div>
            </div>
        </div>
        <div class="row">
            <div class="col card col-lg-4">
                <div class="highlighted">Novagrain</div>
                <div>Coopérative céréalière de 550 adhérents du sud de la Marne</div>
            </div>
            <div class="col card">
                <div class="highlighted">Cérésia</div>
                <div>Coopérative céréalière de 6000 adhérents, classée 11 ème coopérative de France</div>
            </div>
        </div>
   </div>

</template>

<script >
export default {
    name: 'Clients',
    components:{},
    props:{}
}
</script>

<style lang="scss" scoped>

 .container-fluid{
     padding-left: 5vh;
     padding-right: 5vh;
     .card{
        border-radius: 20px;
        padding: 20px;
        .highlighted{
            padding: 0px;
            margin: 0px;
        }
     }
 }
</style>